import { AbstractControl } from '@angular/forms';
import { IonContent, NavController } from '@ionic/angular';
import { AfterViewInit, Component, Input, OnInit, ViewChild, } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ResponsibleGamingService } from 'src/app/services/responsible-gaming-service/responsible-gaming.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { CurrencyFormatterPipe } from 'src/app/pipes/currency-formatter/currency-formatter.pipe';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { BalanceModel } from 'src/app/models/balance-model';
import { DateFormatPipe } from 'src/app/pipes/date-format/date-format.pipe';
import { LimitsService } from 'src/app/services/limits/limits.service';
import { SiteContentInterface } from 'src/app/interfaces/sitecontent-interface';
import { SiteContentModel } from 'src/app/models/sitecontent-model';
import { SiteContentService } from 'src/app/services/sitecontent/sitecontent.service';

@Component({
  selector: 'app-set-single-bet-limits',
  templateUrl: './set-single-bet-limits.component.html',
  styleUrls: ['./set-single-bet-limits.component.scss'],
})
export class SetSingleBetLimitsComponent implements OnInit, AfterViewInit {
    @Input() previousPage: string = "";
    @ViewChild('Content', {read: IonContent, static: false}) content: IonContent;

    public error = null;

    public wagerLimitsForm: FormGroup;

    public labels: SiteContentInterface;

    public wager_single_max_limit: AbstractControl;
    public singleLimitError: boolean;
    public singleWagerLimits: any;


    public wagerLimits: any[] = [];

    public globalSingleMaxLimit: any;

    public globalLimits: any[] = [];

    private floatingPointValidator = "^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$";

    public currentLimit: any;

    public currency: any;


    constructor(
    private siteContentService: SiteContentService,
    private responsibleGamingProvider: ResponsibleGamingService,
    public successMessageProvider: SuccessMessageService,
    public navCtrl: NavController,
    public utils: UtilsService,
    public currencyFormatterPipe: CurrencyFormatterPipe,
    public accountBalanceService: AccountBalanceService,
    public dateFormatPipe: DateFormatPipe,
    public limitsService: LimitsService) {
        this.labels = new SiteContentModel();
        this.successMessageProvider.clearMessage();
        this.error = null;
    }

    ngAfterViewInit(){
        this.siteContentService.loadConfig('single_bet_limit')
            .then((response: SiteContentInterface) => {
            this.labels = response
            })
    }

    ngOnInit() {
        this.wagerLimitsForm = new FormGroup(
            {
                wager_single_max_limit: new FormControl('', [Validators.pattern(this.floatingPointValidator)])
            },  this.atLeastOneFieldValidator
        );

        this.wager_single_max_limit = this.wagerLimitsForm.get('wager_single_max_limit');

        this.getGlobalLimits();
        this.getWagerLimits();

        // we need to get currency
        this.accountBalanceService.getBalance().subscribe((response: BalanceModel) =>{
            this.currency = response.getDefaultCurrency();
        });
    }

    getGlobalLimits() {
        this.responsibleGamingProvider.getGlobalLimits().subscribe({
            next: (response: any) => {
                if (response && !!response.result) {
                    this.globalLimits = response.payload.filter((limit) => {
                        return limit.limitType == "WAGER";
                    });

                    this.globalLimits.forEach((limit) => {
                        if (limit.limitTermType == "SINGLE") {
                            this.globalSingleMaxLimit = parseInt(limit.currentLimit);
                            this.wager_single_max_limit.setValidators([Validators.pattern(this.floatingPointValidator), Validators.max(this.globalSingleMaxLimit)]);
                        }
                    });
                }
            },
            error: (error) => {
                this.error = error;
                this.content.scrollToTop(10);
            }
        });
    }

    getWagerLimits() {
        let tempLimits: any[] = [];

        this.responsibleGamingProvider.getWagerLimit().subscribe({
            next: (response: any) => {
                if (response && !!response.result) {
                    tempLimits = response.payload;

                    for (const index in tempLimits) {
                        if (tempLimits[index].limitSource != "GLOBAL") {
                            this.wagerLimits.push(tempLimits[index]);
                        }
                    }

                    this.updateWagerLimits(this.wagerLimits);
                }
            },
            error: (error) => {
                this.error = error;
                this.content.scrollToTop(10);
            }
        });
    }

    updateWagerLimits(wagerLimits: any[]) {
        this.wager_single_max_limit.setValue("");

        this.wager_single_max_limit.markAsPristine();

        for (const i in wagerLimits) {
            if (wagerLimits[i] != null) {
                if (wagerLimits[i].currentLimitTermType == "SINGLE") {
                    this.singleWagerLimits = wagerLimits[i];
                }
            }
        }
    }

    deleteLimit(term: string) {
        this.successMessageProvider.clearMessage();
        this.error = null;

        const requestObj: any = {};
        requestObj.termType = term.toUpperCase();

        this.responsibleGamingProvider.deleteWagerLimit(requestObj).subscribe({
            next: (response: any) => {
                if (response && !!response.result) {
                    this.getWagerLimits();
                }
            },
            error: (error) => {
                this.error = error;
                this.content.scrollToTop(10);
            }
        });
    }

    setLimits( ) {
        this.successMessageProvider.clearMessage();
        this.error = null;

        const toBeValue = this.wagerLimitsForm.value.wager_single_max_limit
        const maxLimit =   this.globalSingleMaxLimit ? this.globalSingleMaxLimit : undefined;
        if( !maxLimit || toBeValue <= maxLimit) return this.continueSetLimits();
        if(toBeValue < this.currentLimit) return this.continueSetLimits();
        this.error = "New limit is equal to or greater than current limit."
        this.content.scrollToTop(10);;
        return;
    }

    continueSetLimits(){
        this.responsibleGamingProvider.setWagerLimit(this.wagerLimitsForm.value).subscribe({
            next: (response: any) => {
                if (response && !!response.result ) {
                    this.getWagerLimits();

                    this.successMessageProvider.setMessage('Your single bet limit was set.');
                    this.content.scrollToTop(10);
                }
            },
            error: (error) => {

                switch (error.getErrorCode().toUpperCase()) {
                    case 'INVALID_TERM_TYPE':
                        error.setErrorMessage('Limit cannot be 0!');
                        break;
                    default:
                        error.setErrorMessage('');
                        break;
                }
                this.error = error;
                this.content.scrollToTop(10);
            }
        });
    }

    singleMaxLimitChanged() {
        if (this.globalSingleMaxLimit != null) {
            this.singleLimitError = parseInt(this.wager_single_max_limit.value) > parseInt(this.globalSingleMaxLimit);
        }
    }

    atLeastOneFieldValidator(group: FormGroup): {[key: string]: any} {
        let isAtLeastOne = false;
        if (group && group.controls) {
            for (const control in group.controls) {
                if (Object.prototype.hasOwnProperty.call(group.controls, control) && group.controls[control].valid && group.controls[control].value) {
                    isAtLeastOne = true;
                    break;
                }
            }
        }
        return isAtLeastOne ? null : { 'required': true };
    }

    enterPressed() {
        if(!this.wagerLimitsForm.invalid) {
        this.setLimits();
        }
    }

    onClose = () =>{
        this.limitsService.onCloseCommon(this.previousPage == "SignupResult");
    }
}
